module.exports = __webpack_public_path__ + "img/user6-128x128.11686717.jpg";